/** Auth: LoginPage, RequireAuth, SessionBridge (`features/auth/*`). */
export const auth = {
  'auth.login.title': 'Sign in',
  'auth.login.username': 'Username',
  'auth.login.password': 'Password',
  'auth.login.submit': 'Sign in',
  'auth.session.expired': 'Your session expired. Sign in to keep syncing.',
  'auth.login.appName': 'Notebook',
  'auth.login.subtitle': 'Sign in to your notebook.',
  'auth.login.submitting': 'Signing in…',
  'auth.login.submitLocked': 'Try again in {countdown}',
  'auth.login.lockout': 'Too many attempts. Try again in {countdown}.',
  'auth.login.error.badCredentials': 'Incorrect username or password.',
  'auth.login.error.network': "Couldn't sign in. Check your connection and try again.",
  'auth.login.error.validation': 'Enter a username and a password.',
  'auth.login.error.generic': "Couldn't sign in.",
  'auth.boot.loading': 'Loading',
  'auth.offline.title': 'Couldn’t reach the server.',
} as const;
